module.exports = __webpack_public_path__ + "static/img/blnk_img.6914940.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/locale/ko/images/blnk_img.png
// module id = LY/z
// module chunks = 25